(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('AirForm', AirForm);

    /* @ngInject */
    function AirForm($resource) {
        var resourceUrl = 'api/applets/authoring/:id';
        var activeAirformUrl = 'api/applets/authoring?';
        var familiesUrl = 'api/applets/families';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'getActiveAirform': {
                method: 'GET',
                isArray: true,
                url: activeAirformUrl
            },
            'getFamilies': {
                method: 'GET',
                isArray: true,
                url: familiesUrl
            },
            'getFamilyVersions': {
                method: 'GET',
                isArray: true,
                url: 'api/applets/authoring/:familyId/history'
            }
        });
    }
})();
